import { compileWasm } from '@unni-craftsman/turso-fts'
import { compileTursoWasm } from '../compile-turso-wasm'

let pageWasm: WebAssembly.Module | undefined
let pageWasmPreparation: Promise<WebAssembly.Module> | undefined

export async function preparePageWasm(): Promise<WebAssembly.Module> {
  if (pageWasm) return pageWasm
  const preparing = pageWasmPreparation ??= compileTursoWasm(compileWasm)
  try {
    pageWasm ??= await preparing
    return pageWasm
  } finally { if (pageWasmPreparation === preparing) pageWasmPreparation = undefined }
}

export function getTursoWasm(): WebAssembly.Module | undefined { return pageWasm }

/** Adopt the page-compiled module before this worker creates an engine. */
export function receiveTursoWasm(wasm: WebAssembly.Module): void {
  pageWasm ??= wasm
}

